<template>
  <div id="Wizard-2" class="vh-100">
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: "Wizard-2",
  beforeRouteUpdate(to, from, next) {
    next();
  }
};
</script>

<style>
.title-area {
  width: 100%;
  min-height: 110px;
}
.input-area {
  min-height: 138px;
}
.fixed-bottom {
  position: fixed;
  left: 0;
  bottom: 0;
  right: 0;
  padding-bottom: 23px;
  z-index: 2;
}
</style>


// WEBPACK FOOTER //
// src/components/templates/Wizard.vue